<!--suppress CheckEmptyScriptTag -->
<template>
  <div class="page-combo-detail-container">
    <bottom-bar-layout v-if="loaded"
                       class="page-combo-detail"
                       :show-bar="render.bottomBar.show"
                       :bar-height="render.benefitBar && render.benefitBar.show ? 180 : 120"
                       :target-id="combo.id"
                       :target-type="type"
                       :show-consult="render.showConsult"
                       is-show-share
                       :is-show-guide-popup="false"
    >
      <!-- 头部 -->
      <combo-header :cover="combo.cover"
                    :tag="render.tag"
                    :title="combo.title"
                    :id="combo.id"
                    :type="type"
                    :tags="combo.tags"
                    :products="combo.products"
                    :sub-title="combo.liveTimeDesc"
                    :team-size="teamSize"
                    :join-status="combo.joinStatus"
                    :price="render.primaryPrice"
                    :show-get-point="render.showSharePoint"
                    :gift="render.gift"
                    :collect="render.collect"
                    @disabledJoin="handleDisabledJoin"
      >
        <group-buy-block-header class="group-buy-activity-header"
                                v-if="groupBuy.activity && !showGroupBuyList"
                                :rule="groupBuy.activity.rule"
                                :start-time="groupBuy.activity.currentTime"
                                :end-time="groupBuy.activity.endTime"
        />
      </combo-header>

      <member-notice :id="combo.id"
                     :type="type"
                     :qr-code="qrCode"
                     :wechat-group="wechatGroup"
                     :guide-info="guideInfo"
      />

      <!-- 拼团 -->
      <group-buy-block class="group-buy-block"
                       v-if="showGroupBuyList"
                       :id="groupBuyActivityId"
                       :desc="groupBuy.activity.desc"
                       :rule="groupBuy.activity.rule"
                       :start-time="groupBuy.activity.currentTime"
                       :end-time="groupBuy.activity.endTime"
                       :list="groupBuy.activity.team.list"
                       :max-list-num="groupBuy.activity.team.max"

      />

      <product-block v-if="combo.products.list.length !== 0"
                     :list="combo.products.list"
      />
      <recommend-reviews v-if="recommendReviews.length !== 0"
                         :list="recommendReviews"
                         @click-more="handleRecommendReviewsShowMore"
      />
      <gains-block v-if="showStudentGains"
                   :list="studentGains.list"
                   @click-more="handleStudentGainsShowMore"
      />
      <product-content v-model="tabSelected"
                       id="product-detail-content-block"
                       :nav-bar-list="navBarList"
                       product-type="courseCombo"
                       :product="combo"
                       :reviews="reviews"
                       :works="works"
                       :student-gains="studentGains"
      />

      <!-- bottom bar -->
      <template #tabbar>
        <bottom-bar :benefit-bar="render.benefitBar"
                    :sell="combo.sell"
                    :product="product"
                    :render-price="render.bottomBar.renderPrice"
                    :action-bar="render.bottomBar.actionBar"
                    :my-team-id="groupBuy.myTeamId"
                    @disabledJoin="handleDisabledJoin"
        />
      </template>
      <!-- 购课补贴 -->
      <subsidy-info :subsidy-info="subsidyInfo"
                    :id="combo.id"
                    :type="type"
      />

    </bottom-bar-layout>
    <empty-page v-else
                hint="正在加载数据..."
    />
  </div>

</template>

<script>
  import EmptyPage from '@/components/EmptyPage';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import ComboHeader from '@/components/ProductDetailHeader';
  import GroupBuyBlock from '@/pages/GroupBuy/components/ProductDetailBlock';
  import ProductBlock from '@/pages/Combo/components/ComboDetailProductList';
  import GroupBuyBlockHeader from '@/pages/GroupBuy/components/ProductDetailBlockHeader';
  import ProductContent from '@/components/ProductDetail/Content';
  import BottomBar from '@/components/ProductDetailBottom/Bar';
  import SubsidyInfo from '@/pages/Combo/components/SubsidyInfoPopup';
  import MemberNotice from '@/components/ProductDetailMemberNotice';
  import { getCourseComboDetail } from '@/services/combo';
  import RecommendReviews from '@/components/ProductDetailRecommendReviews/index';
  import GainsBlock from '@/pages/StudentGains/components/ProductDetailBlock';
  import event from '@/utils/bus';

  export default {
    name: 'CourseComboDetail',
    metaInfo() {
      return {
        title: this.combo.title,
      };
    },
    components: {
      EmptyPage,
      BottomBarLayout,
      ComboHeader,
      ProductBlock,
      GroupBuyBlock,
      GroupBuyBlockHeader,
      ProductContent,
      BottomBar,
      SubsidyInfo,
      MemberNotice,
      RecommendReviews,
      GainsBlock,
    },
    data() {
      return {
        type: 'courseCombo',
        loaded: false,
        combo: {
          id: 0,
          type: '',
          tags: [],
          cover: '',
          title: '',
          subTitle: '',
          products: {
            list: [],
          },
          sell: {
            startTime: '',
            status: '',
          },
        },

        tabSelected: 'intro',

        reviews: {
          list: [],
          start: 0,
        },
        works: {
          list: [],
          start: 0,
        },

        groupBuy: {
          activity: null,
          myTeamId: 0,
        },

        render: {
          showSharePoint: false,
          tag: null,
          primaryPrice: {
            current: {
              value: 0,
              name: '',
            },
            origin: {
              value: 0,
              name: '',
            },
            benefit: null,
          },
          benefitBar: {
            show: false,
            desc: '',
            startTime: 0,
            endTime: 0,
          },
          bottomBar: {
            show: false,
            actionBar: {
              type: 'default',
              buttons: [],
            },
            renderPrice: {
              value: 0,
              delete: 0,
              name: '',
            },
          },
          showConsult: false,
          navBar: [
            {
              name: '系列简介',
              type: 'intro',
              show: true,
            },
            {
              name: '评价',
              type: 'review',
              show: true,
            },
            {
              name: '作品',
              type: 'work',
              show: true,
            },
          ],
        },
        subsidyInfo: null,
        qrCode: null,
        wechatGroup: null,
        guideInfo: null,
        recommendReviews: [],
        studentGains: null,
      };
    },
    computed: {
      groupBuyTeamLength() {
        if (!this.groupBuy.activity) return 0;
        return this.groupBuy.activity.team.list.length;
      },
      showGroupBuyList() {
        return this.groupBuyTeamLength > 0;
      },
      groupBuyActivityId() {
        return this.groupBuy.activity ? parseInt(this.groupBuy.activity.id, 10) : 0;
      },
      teamSize() {
        return this.groupBuy.activity ? this.groupBuy.activity.teamSize : 0;
      },
      product() {
        return { type: 'courseCombo', id: this.combo.id, price: this.render.primaryPrice.origin.value };
      },
      workQuery() {
        const { type: targetType, combo } = this;
        const { id: targetId } = combo;
        return {
          targetType,
          targetId,
        };
      },
      navBarList() {
        return this.render.navBar.filter(item => item.show);
      },
      showStudentGains() {
        return this.studentGains && this.studentGains.list && this.studentGains.list.length === 2;
      },
    },
    methods: {
      handleRecommendReviewsShowMore() {
        this.tabSelected = 'review';
        document.getElementById('product-detail-content-block').scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      },
      handleStudentGainsShowMore() {
        this.tabSelected = 'studentGains';
        document.getElementById('product-detail-content-block').scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      },
      async getComboDetail(id) {
        const data = await getCourseComboDetail(id);

        data.combo.products.list.forEach((item) => {
          item.link = true;
          return item;
        });

        this.combo = data.combo;

        this.reviews = data.reviews;

        this.works = data.works;

        this.groupBuy = data.groupBuy;

        this.render = data.render;

        this.combo.products.isPreSale = data.combo.products.isPreSale;

        this.subsidyInfo = data.subsidyInfo;
        this.qrCode = data.qrCode || { title: '', hint: '', src: '' };
        this.wechatGroup = data.wechatGroup;
        this.guideInfo = data.guideInfo;
        this.recommendReviews = data.recommendReviews;
        this.studentGains = data.studentGains;
        this.loaded = true;
      },
      handleDisabledJoin() {
        this.getComboDetail(this.combo.id);
      },
    },
    created() {
      const { id } = this.$route.params;
      this.getComboDetail(id);
      event.$once('updateDetail', () => {
        this.getComboDetail(id);
      });
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.getComboDetail(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-combo-detail-container {
    min-height: 100%;
    background: @color-white;
  }

  .tab {
    .num {
      color: @color-text-lighter;
      font-size: @font-size-small;
      margin-left: @size-extra-small;
    }
  }

  .tab-content-container {
    min-height: @product-tab-min-height;
    background-color: @color-white;
  }

  .combo-intro {
    padding-bottom: @tabbar-join-height;
    /deep/ p {
      margin: 0;
    }
    /deep/ img, /deep/ iframe {
      display: block;
      max-width: 100%;
    }
    /deep/ video {
      display: block;
      margin: 0 auto;
      width: 690px;
      height: 388px;
    }
  }

  .group-buy-block {
    margin-bottom: @size-small;
  }

</style>
